import React from 'react'
import { Link } from "react-router-dom";


const Gynaecology = () => {
  return (
    <>
      <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
        <div className="auto-container">
          <h2>Gynaecology</h2>
          <ul className="bread-crumb clearfix">
            <li><Link to="/">Home</Link></li>
            <li style={{ color: "green" }}>Gynaecology</li>
          </ul>
        </div>
      </section>

      <div className="sidebar-page-container left-sidebar" style={{ marginTop: "-100px" }}>
        <div className="auto-container">
          <div className="row clearfix">
            {/* Sidebar Side */}
            <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
              <aside className="sidebar sticky-top">
                {/* Department Widget */}
                <div className="sidebar-widget department-widget">
                  <div className="widget-content">
                    <ul className="department-list">
                      <li className="active"><Link to="/gynaecology">Gynaecology</Link></li>
                      <li ><Link to="/general-surgery">General Surgery</Link></li>
                      <li><Link to="/general-medicine">General Medicine</Link></li>
                      <li ><Link to="/gastroenterology">Gastroenterology</Link></li>
                      <li><Link to="/orthopedic">Orthopedic</Link></li>
                      <li><Link to="/neurology">Neurology</Link></li>
                      <li><Link to="/neurosurgery">Neurosurgery</Link></li>
                      <li><Link to="/paediatrics">Paediatrics</Link></li>
                      <li ><Link to="/neuropsychiatrist">Neuropsychiatrist</Link></li>

                    </ul>
                  </div>
                </div>
                {/* Time Widget */}
                {/* <div className="sidebar-widget time-widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <span className="clock_icon flaticon-clock" />
                      <h4>Working Time</h4>
                      <ul className="working-time_list">
                        <li>Mon-Thu <span>08:00 - 20:00</span></li>
                        <li>Friday <span>07:00 - 22:00</span></li>
                        <li>Saturday <span>08:00 - 18:00</span></li>
                      </ul>
                    </div>
                  </div>
                </div> */}
                {/* Time Widget */}
                <div className="sidebar-widget contact-info_widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <h4>Contact Info</h4>
                      <ul className="contact-info_widget-list">
                        <li><span className="icon fa-solid fa-phone fa-fw" /><Link style={{ color: "black" }} to='https://share.google/fCIHbcmFHPs4QBm5t' target="_blank">सतना स्वास्तिक हॉस्पिटल पन्नीलाल चौक, सतना (म.प्र.)</Link></li>
                        <li><span className="icon fa-solid fa-envelope fa-fw" /> <Link style={{ color: "black" }} to="mailto:satnaswastikhospital@gmail.com">satnaswastikhospital@gmail.com</Link></li>
                        {/* <li><span className="icon fa-solid fa-clock fa-fw" />Mon - Sat 8:00 - 6:30, <br /> Sunday - CLOSED</li> */}
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Expert Widget */}
                <div className="sidebar-widget expert_widget" style={{ backgroundImage: 'url(assets/images/background/pattern-33.png)' }}>
                  <span className="color-layer" />
                  <h3>Experienced Team of Doctors, Nurses, and Staff</h3>
                  <Link to="/appointment" className="theme-btn btn-style-one">
                    <span className="btn-wrap">
                      <span className="text-one">Book Appointment</span>
                      <span className="text-two">Book Appointment</span>
                    </span>
                  </Link>
                  <div className="image">
                    <img src="assets/images/resource/doctor-1.png" alt />
                  </div>
                </div>
              </aside>
            </div>
            {/* Content Side */}
            <div className="content-side col-lg-8 col-md-12 col-sm-12">
              <div className="department-detail">
                <div className="inner-box">
                  <div className="image">
                    <img src="assets/img/Gynaecolog.jpg" alt />
                  </div>
                  <h3>Gynaecology</h3>
                  <p> Satna Swastik Hospital gynaecology department is a comprehensive unit that provides all services for women's reproductive and gynecological requirements in a thorough, considerate, and committed manner. The obstetrics and gynecology section is constantly ready to support women during pregnancy, menopause, and other life phases.</p>

                  <h3>Conditions we treat</h3>
                  <div className="graph-outer">
                    <div className="row clearfix">
                      <div className="column col-lg-12 col-md-12 col-sm-12">
                        <ul className="list">
                          <li>Uterus/Ovarian Cancer Treatment</li>
                          <li>Irregular Periods</li>
                          <li>PCOD</li>
                          <li>Fibroid</li>
                          <li>Abdominal & Vaginal Hysterectomy</li>
                          <li>Hysteroscopy</li>
                          <li>Postmenopausal Symptoms Treatment</li>
                          <li>Normal & High-Risk Pregnancy</li>
                          <li> Normal & Painless Delivery</li>
                          <li> Cesarean Section</li>
                          <li> Infertility </li>

                        </ul>
                      </div>

                    </div>
                  </div>

                  <h3>Specialists</h3>
                  <div className=" col-lg-6 col-md-12 col-sm-12">
                    <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                      <div className="image">
                        <img src="assets/img/Dr. Subhashini Mishra.webp" alt style={{ width: "200px", height: "200px", borderRadius: "100px" }} />
                      </div>
                      <div className="lower-content">
                        <div className="content">
                          <h5 style={{ textAlign: "justify", marginTop: "-22px" }}><a to="#" style={{ textAlign: "center" }}>Dr. Subhashini Mishra</a></h5>
                          <div className="designation" style={{ textAlign: "justify" }}>MBBS, (Obstetrics & Gynecology)</div>


                        </div>
                        {/* <a to="#" className="plus-box flaticon-plus" /> */}
                      </div>
                    </div>
                  </div>
                  {/* <div className="image">
                    <img src="assets/img/Dr. Divyant Gupta.webp" alt style={{width:"200px", height:"200px", borderRadius:"100px"}} />
                  </div>
                  <p><strong>Electrocardiogram (ECG or EKG): </strong>this records the electrical activity of the heart.</p> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>




    </>
  )
}

export default Gynaecology